import React, { useCallback } from 'react'
import clsx from 'clsx'
import { useDropzone } from 'react-dropzone'
import Icon from '../Icon/Icon'

export const MinimalFileInput = ({
  otherClasses,
  fileLabel,
  setState,
  inputName,
  fileNameToDisplay,
  warning,
}) => {
  const onDrop = useCallback((acceptedFiles) => {
    setState((prev) => ({
      ...prev,
      [inputName]: acceptedFiles[0],
    }))
    // setFile(acceptedFiles[0])
  }, [])
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    noClick: true,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
      'application/vnd.ms-excel': [],
    },
  })

  const minimalFileInputClasses = clsx(
    otherClasses,
    'flex flex-col lg:flex-row mb-3 w-full ',
    warning ? 'border-[#ff4444]' : 'border-[#B2B2B2]'
  )

  return (
    <div className={minimalFileInputClasses}>
      <label className="flex flex-col gap-y-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-3 ">
          <div
            className="border-[1px] border-[#B2B2B2] text-primary_dark_blue_500 border-dashed flex gap-x-2 py-2 px-[14px] items-center cursor-pointer"
            {...getRootProps()}
          >
            <Icon
              icon="upload-icon"
              iconHeight={16}
              iconWidth={16}
              className="flex items-center justify-center"
            />
            <div>Upload file</div>
          </div>
          <div className="flex flex-col items-center gap-1">
            {fileNameToDisplay ? (
              <p className="text-sm leading-5 text-gray-400 font-Mulish font-normal ">
                {fileNameToDisplay}
              </p>
            ) : (
              <p
                className={clsx(
                  'text-sm leading-5  font-Mulish font-normal ',
                  warning ? 'text-[#ff4444]' : 'text-gray-400'
                )}
              >
                Upload {fileLabel} (Max file size 10MB)
              </p>
            )}
            <input
              required={true}
              id="file"
              name={inputName}
              type="file"
              hidden
              {...getInputProps()}
            />
          </div>
        </div>
      </label>
    </div>
  )
}

export default MinimalFileInput
